import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import {
  apiUrl,
  clientheaderconfig,
  ecommerceapiUrl,
} from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
var module = "company";
var moduleName = "Additional Charge";
var modulePath = "/clientpanel/outlet";
const AdditionalCharges = {
  timeBased: [
    {
      title: "",
      fromTime: "",
      toTime: "",
      outlet: [],
      availabilty: [],
      amount: "",
    },
  ],
  dateBased: [
    {
      title: "",
      fromDate: "",
      toDate: "",
      outlet: [],
      availabilty: [],
      amount: "",
    },
  ],
  customCharge: [
    {
      title: "",
      amount: "",
      type: "",
      outlet: [],
      availabilty: [],
    },
  ],
};
class AdditionalCharge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageloading: false,
      companyAdditionalCharge: AdditionalCharges,
      btndisabled: false,
      loading: true,
      tatList: [],
      formpost: [],
      companyDetail: [],

      outletList: [],
      availabiltyList: [],
    };
  }
  componentDidMount = async () => {
    var params = {
      url: apiUrl + module + "/getCompanySettings",
      type: "client",
    };
    this.setState({ pageloading: true });
    this.props.getDetailData(params);
    this.loadOutlet();
    this.loadAvailabilty();
  };
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost !== nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0]?.message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
        this.setState({btndisabled:true})
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;
          const companyAdditionalCharge = result.companyAdditionalCharge ?? "";
          const companyAdditionalCharges =
            companyAdditionalCharge !== "" && companyAdditionalCharge !== null
              ? JSON.parse(companyAdditionalCharge)
              : AdditionalCharges;
          this.setState({
            companyAdditionalCharge: companyAdditionalCharges,
            pageloading: false,
          });
        } else {
          this.setState({ pageloading: false, });
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid Product", "error");
        }
      });
    }
  }

  loadOutlet() {
    var urlShringTxt = ecommerceapiUrl + "outlet/dropDownList";
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ outletList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  loadAvailabilty() {
    var urlShringTxt = ecommerceapiUrl + "availability/companydropDownList";
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ availabiltyList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }


  handleSubmit = () => {
    this.setState({btndisabled:true})
    showLoader("submit_frm", "class");
    var postObject = {
      companyAdditionalCharge: JSON.stringify(
        this.state.companyAdditionalCharge
      ),
    };

    var post_url = `${module}/updateSetting`;
    const method = "update";
    this.props.getFormPost(postObject, post_url, "client", method);
  };
  addData(type) {
    let companyAdditionalCharge = this.state.companyAdditionalCharge;
    if (type === "timeBased") {
      companyAdditionalCharge.timeBased.push({
        fromTime: "",
        toTime: "",
        outlet: [],
        availabilty: [],
        amount: "",
      });
    } else if (type === "dateBased") {
      companyAdditionalCharge.dateBased.push({
        fromDate: "",
        toDate: "",
        outlet: [],
        availabilty: [],
        amount: "",
      });
    } else if (type === "customCharge") {
      companyAdditionalCharge.customCharge.push({
        title: "",
        amount: "",
        type: "",
        outlet: [],
        availabilty: [],
      });
    }

    this.setState({ companyAdditionalCharge });
  }
  removeData(type, removeIndex) {
    let companyAdditionalCharge = this.state.companyAdditionalCharge;
    if (type === "timeBased") {
      companyAdditionalCharge.timeBased.splice(removeIndex, 1);
    } else if (type === "dateBased") {
      companyAdditionalCharge.dateBased.splice(removeIndex, 1);
    } else if (type === "customCharge") {
      companyAdditionalCharge.customCharge.splice(removeIndex, 1);
    }
    this.setState({ companyAdditionalCharge });
  }

  changeData(changeIndex, changeType, name, value) {
    let companyAdditionalCharge = this.state.companyAdditionalCharge;
    companyAdditionalCharge[changeType][changeIndex][name] = (value===null)?'':value;
    this.setState({ companyAdditionalCharge });
  }

  changeText(changeIndex, changeType, name, event) {
    if (name === "amount") {
      event.target.value = event.target.value.replace(/[^\d.]/g, "");
    }

    let companyAdditionalCharge = this.state.companyAdditionalCharge;
    companyAdditionalCharge[changeType][changeIndex][name] = event.target.value;
    this.setState({ companyAdditionalCharge });
  }

  render() {
    const cAdditionalCharge = this.state.companyAdditionalCharge;
    return (
      <div className="layout-wrapper layout-content-navbar acctinalCharge">
        <div className="layout-container">
          <Header {...this.props} currentPage="settings" />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-9 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                </div>

                <form className="card fv-plugins-bootstrap5" id="modulefrm">
                  <div className="card-body  g-3 mt-2">
                    {cAdditionalCharge.timeBased.length > 0 && (
                      <div>
                        <h5 className="card-header">Based On Time</h5>
                        {cAdditionalCharge.timeBased.map((item, index) => {
                          return (
                            <div className="row" key={index}>
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline mb-4">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="productSpecialPrice"
                                    onChange={this.changeText.bind(
                                      this,
                                      index,
                                      "timeBased",
                                      "title"
                                    )}
                                    value={item.title}
                                  />
                                  <label>Title</label>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline mb-4">
                                  <DatePicker
                                    className="form-control"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={10}
                                    timeCaption="Time"
                                    dateFormat="h:mm aa"
                                    onChange={this.changeData.bind(
                                      this,
                                      index,
                                      "timeBased",
                                      "fromTime"
                                    )}
                                    selected={
                                      item.fromTime !== ""
                                        ? new Date(item.fromTime)
                                        : ""
                                    }
                                  />

                                  <label className="date-picker-label">
                                    From Time
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline mb-4">
                                  <DatePicker
                                    className="form-control"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={10}
                                    timeCaption="Time"
                                    dateFormat="h:mm aa"
                                    onChange={this.changeData.bind(
                                      this,
                                      index,
                                      "timeBased",
                                      "toTime"
                                    )}
                                    selected={
                                      item.toTime !== ""
                                        ? new Date(item.toTime)
                                        : ""
                                    }
                                  />

                                  <label className="date-picker-label">
                                    To Time <span className="error">*</span>
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline custm-select-box mb-4">
                                  <Select
                                    placeholder={"Select Outlet"}
                                    options={this.state.outletList}
                                    isClearable={true}
                                    isMulti
                                    onChange={this.changeData.bind(
                                      this,
                                      index,
                                      "timeBased",
                                      "outlet"
                                    )}
                                    value={item.outlet}
                                  />
                                  <label className="select-box-label">
                                    Outlet
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline custm-select-box mb-4">
                                  <Select
                                    isMulti
                                    placeholder="Select Availabilty"
                                    options={this.state.availabiltyList}
                                    isClearable={true}
                                    onChange={this.changeData.bind(
                                      this,
                                      index,
                                      "timeBased",
                                      "availabilty"
                                    )}
                                    value={item.availabilty}
                                  />
                                  <label className="select-box-label">
                                    Availabilty
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-1">
                                <div className="form-floating form-floating-outline mb-4">
                                  <input
                                    type="text"
                                    className="form-control"
                                    onChange={this.changeText.bind(
                                      this,
                                      index,
                                      "timeBased",
                                      "amount"
                                    )}
                                    value={item.amount}
                                  />
                                  <label>Amount</label>
                                </div>
                              </div>
                              <div className="col-md-1">
                                <div className="mt-3">
                                  {cAdditionalCharge.timeBased.length > 1 && (
                                    <span
                                      className="act-minus-icon"
                                      onClick={this.removeData.bind(
                                        this,
                                        "timeBased",
                                        index
                                      )}
                                    >
                                      <i className="mdi mdi-minus-circle-outline"></i>
                                    </span>
                                  )}
                                  {(cAdditionalCharge.timeBased.length === 1 || cAdditionalCharge.timeBased.length - 1 === index) && (
                                    <span
                                      className="act-plus-icon"
                                      onClick={this.addData.bind(
                                        this,
                                        "timeBased"
                                      )}
                                    >
                                      <i className="mdi mdi-plus-circle-outline"></i>
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {cAdditionalCharge.dateBased.length > 0 && (
                      <div>
                        <hr />
                        <h5 className="card-header">Based On Date</h5>
                        {cAdditionalCharge.dateBased.map((item, index) => {
                          return (
                            <div className="row" key={index}>
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline mb-4">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="productSpecialPrice"
                                    onChange={this.changeText.bind(
                                      this,
                                      index,
                                      "dateBased",
                                      "title"
                                    )}
                                    value={item.title}
                                  />
                                  <label>Title</label>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline mb-4">
                                  <DatePicker
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="form-control"
                                    minDate={new Date()}
                                    dateFormat="dd/MM/yyyy"
                                    onChange={this.changeData.bind(
                                      this,
                                      index,
                                      "dateBased",
                                      "fromDate"
                                    )}
                                    selected={
                                      item.fromDate !== ""
                                        ? new Date(item.fromDate)
                                        : ""
                                    }
                                  />

                                  <label className="date-picker-label">
                                    From Date
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline mb-4">
                                  <DatePicker
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="form-control"
                                    minDate={new Date()}
                                    dateFormat="dd/MM/yyyy"
                                    onChange={this.changeData.bind(
                                      this,
                                      index,
                                      "dateBased",
                                      "toDate"
                                    )}
                                    selected={
                                      item.toDate !== ""
                                        ? new Date(item.toDate)
                                        : ""
                                    }
                                  />

                                  <label className="date-picker-label">
                                    To Date
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline custm-select-box mb-4">
                                  <Select
                                    placeholder={"Select Outlet"}
                                    options={this.state.outletList}
                                    isClearable={true}
                                    isMulti
                                    onChange={this.changeData.bind(
                                      this,
                                      index,
                                      "dateBased",
                                      "outlet"
                                    )}
                                    value={item.outlet}
                                  />
                                  <label className="select-box-label">
                                    Outlet
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline custm-select-box mb-4">
                                  <Select
                                    isMulti
                                    placeholder="Select Availabilty"
                                    options={this.state.availabiltyList}
                                    isClearable={true}
                                    onChange={this.changeData.bind(
                                      this,
                                      index,
                                      "dateBased",
                                      "availabilty"
                                    )}
                                    value={item.availabilty}
                                  />
                                  <label className="select-box-label">
                                    Availabilty
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-1">
                                <div className="form-floating form-floating-outline mb-4">
                                  <input
                                    type="text"
                                    className="form-control"
                                    onChange={this.changeText.bind(
                                      this,
                                      index,
                                      "dateBased",
                                      "amount"
                                    )}
                                    value={item.amount}
                                  />
                                  <label>Amount</label>
                                </div>
                              </div>
                              <div className="col-md-1">
                                <div className="mt-3">
                                  {cAdditionalCharge.dateBased.length > 1 && (
                                    <span
                                      className="act-minus-icon"
                                      onClick={this.removeData.bind(
                                        this,
                                        "dateBased",
                                        index
                                      )}
                                    >
                                      <i className="mdi mdi-minus-circle-outline"></i>
                                    </span>
                                  )}
                                  {(cAdditionalCharge.dateBased.length === 1 || cAdditionalCharge.dateBased.length - 1 ===
                                      index) && (
                                    <span
                                      className="act-plus-icon"
                                      onClick={this.addData.bind(
                                        this,
                                        "dateBased"
                                      )}
                                    >
                                      <i className="mdi mdi-plus-circle-outline"></i>
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                    {cAdditionalCharge.customCharge.length > 0 && (
                      <div>
                        <hr />
                        {cAdditionalCharge.customCharge.map((item, index) => {
                          return (
                            <div className="row" key={index}>
                              <h5 className="card-header">Custom Charge</h5>
                              <div className="col-md-3">
                                <div className="form-floating form-floating-outline mb-4">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="productSpecialPrice"
                                    onChange={this.changeText.bind(
                                      this,
                                      index,
                                      "customCharge",
                                      "title"
                                    )}
                                    value={item.title}
                                  />
                                  <label>Title</label>
                                </div>
                              </div>
                              <div className="col-md-1">
                                <div className="form-floating form-floating-outline mb-4">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="productSpecialPrice"
                                    onChange={this.changeText.bind(
                                      this,
                                      index,
                                      "customCharge",
                                      "amount"
                                    )}
                                    value={item.amount}
                                  />
                                  <label>Amount</label>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline custm-select-box mb-4">
                                  <Select
                                    placeholder={"Select Type"}
                                    options={[
                                      {
                                        value: "P",
                                        label: "Percentage",
                                      },
                                      {
                                        value: "F",
                                        label: "Fixed",
                                      },
                                    ]}
                                    isClearable={true}
                                    onChange={this.changeData.bind(
                                      this,
                                      index,
                                      "customCharge",
                                      "type"
                                    )}
                                    value={item.type}
                                  />
                                  <label className="select-box-label">
                                    Type
                                  </label>
                                </div>
                              </div>

                              <div className="col-md-3">
                                <div className="form-floating form-floating-outline custm-select-box mb-4">
                                  <Select
                                    placeholder={"Select Outlet"}
                                    options={this.state.outletList}
                                    isClearable={true}
                                    isMulti
                                    onChange={this.changeData.bind(
                                      this,
                                      index,
                                      "customCharge",
                                      "outlet"
                                    )}
                                    value={item.outlet}
                                  />
                                  <label className="select-box-label">
                                    Outlet
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline custm-select-box mb-4">
                                  <Select
                                    isMulti
                                    placeholder="Select Availabilty"
                                    options={this.state.availabiltyList}
                                    isClearable={true}
                                    onChange={this.changeData.bind(
                                      this,
                                      index,
                                      "customCharge",
                                      "availabilty"
                                    )}
                                    value={item.availabilty}
                                  />
                                  <label className="select-box-label">
                                    Availabilty
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-1">
                                <div className="mt-3">
                                  {cAdditionalCharge.customCharge.length >
                                    1 && (
                                    <span
                                      className="act-minus-icon"
                                      onClick={this.removeData.bind(
                                        this,
                                        "customCharge",
                                        index
                                      )}
                                    >
                                      <i className="mdi mdi-minus-circle-outline"></i>
                                    </span>
                                  )}
                                  {(cAdditionalCharge.customCharge.length === 1 || cAdditionalCharge.customCharge.length - 1 ===
                                      index) && (
                                    <span
                                      className="act-plus-icon"
                                      onClick={this.addData.bind(
                                        this,
                                        "customCharge"
                                      )}
                                    >
                                      <i className="mdi mdi-plus-circle-outline"></i>
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}

                    <div className="pt-1 pb-4 pt-1 text-end">
                      <button
                        type="button"
                        disabled={this.state.btndisabled}
                        className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
                         onClick={(e) => {
                          e.preventDefault();
                          if (!this.props.btndisabled) {
                            this.handleSubmit();
                          }
                        }}
                      >
                        Submit
                      </button>
                      <Link to={modulePath}>
                        <button
                          type="reset"
                          className="btn btn-label-secondary waves-effect"
                        >
                          Cancel
                        </button>
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(AdditionalCharge);
